import { useState, useEffect } from 'react'
import { type EventTypeAttributes } from '@/Views/FormSteps/EventType/Base/Fieldset'
import { useEventTypesQuery } from '@/Views/FormSteps/EventType/Base/Fieldset/Fieldset.generated'

interface EventTypeSectionProps {
  initialEventTypeId?: string
  onChange: (attrs: EventTypeAttributes) => void
}

const EventTypeSection = ({ initialEventTypeId, onChange }: EventTypeSectionProps) => {
  const [eventTypeAttrs, setEventTypeAttrs] = useState<EventTypeAttributes>({
    collection: undefined,
    collectionName: undefined,
  })

  const [{ data }] = useEventTypesQuery({ requestPolicy: 'cache-first' })
  const collections = data?.BBBE_collections ?? []

  useEffect(() => {
    if (!initialEventTypeId || !collections.length) return
    const match = collections.find(
      (c) => c.id === initialEventTypeId || c.id === String(Number(initialEventTypeId))
    )
    if (match) {
      const attrs = { collection: match.id, collectionName: match.name }
      setEventTypeAttrs(attrs)
      onChange(attrs)
    }
  }, [collections, initialEventTypeId])

  const handleChange = (attrs: EventTypeAttributes) => {
    setEventTypeAttrs(attrs)
    onChange(attrs)
  }

  return (
    <div className='w-full flex flex-col gap-4'>
      <p className='!font-bold text-sm sm:text-base text-black leading-6'>
        What are you planning? <span className='text-[#af231c]'>*</span>
      </p>
      <div className='grid grid-cols-2 gap-y-4 gap-x-6 w-full'>
        {collections.map(({ id, name }) => (
          <label
            key={id}
            className='flex items-start gap-2 cursor-pointer select-none min-w-0 w-full'>
            <input
              type='radio'
              name='duplicate-event-type'
              value={id}
              checked={eventTypeAttrs.collection === id}
              onChange={() => handleChange({ collection: id, collectionName: name })}
              className='w-5 h-5 cursor-pointer accent-black shrink-0 mt-0.5'
            />
            <span className='text-sm sm:text-base text-[#1f1f1f] leading-6 break-all whitespace-normal'>
              {name}
            </span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default EventTypeSection
